module.exports = __webpack_public_path__ + "img/Weilin binocular vision software.87553d4d.jpg";